import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { Messages } from 'primereact/messages';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';
import { useAuth } from '../contexts/AuthContext';
import Container from 'react-bootstrap/Container';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { ScrollTop } from 'primereact/scrolltop';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ProgressBar } from 'primereact/progressbar';
import '../config.js';
import useStatusPageScript from '../hooks/useStatusPageScript.js';
import AccessState from './AccessState';
import usePageAccessRedirect from '../hooks/usePageAccessRedirect';

const Clients = () => {
  // Load the status page script
  useStatusPageScript();
  
  const { typeId, typeName, type } = useParams();
  const [clients, setClients] = useState([]);
  const [lmsConversion, setLmsConversion] = useState([]);
  const navigate = useNavigate();
  const [rowSelectionModel, setRowSelectionModel] = useState();
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    status: { value: null, matchMode: FilterMatchMode.EQUALS},
    lms: { value: null, matchMode: FilterMatchMode.STARTS_WITH},
  });
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [lms, setLms] = useState([]);
  const msgs = useRef(null);
  const [createVisible, setCreateVisible] = useState(false);
  const [newClientName, setNewClientName] = useState('');
  const [newClientLms, setNewClientLms] = useState(-1);
  const [newLmsName, setNewLmsName] = useState('');
  const toast = useRef(null);
  const toastBC = useRef(null);
  const op = useRef(null);
  const dt = useRef(null);
  const { accessIssue, clearAccessIssue, handleAccessError } = usePageAccessRedirect({
    deniedTitle: 'Clients Access Denied',
    deniedMessage: 'You do not have permission to view or manage clients for this record.',
  });
  useEffect(() => {
    const fetchClients = async () => {
      getClients();
    };

    fetchClients();

    let _filters = JSON.parse(localStorage.getItem('clients-global'));
    if (_filters) {
      setFilters(_filters);
      setGlobalFilterValue(_filters['global'].value);
    }
  }, [typeId, typeName, type]);



  const getClients = async () => {
    try {
      clearAccessIssue();
      setLoading(true);
      setClients([]);
      const token = localStorage.getItem('token');
      const response = await axios.get(global.config.url + `/clients/By${type}/${typeId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      try{
          const lmsResponse = await axios.get(global.config.url + '/clients/lmsConversion', {
              headers: {
                  Authorization: `Bearer ${token}`,
              },
          });
          setLmsConversion(lmsResponse.data);
          // let dict = sortByFirstDigit(lmsResponse.data);
          setLms(Object.values(lmsResponse.data));
          // setLms(Object.values(lmsResponse.data));
          console.log(lmsResponse.data);
          if(response.data.length === 0){
            setLoading(false);
            setClients([]);
            return;
          }

          let responseLocations = [];
          if(type === 'Customer'){
            responseLocations = await axios.get(global.config.url + '/locations/ByCustomer/' + typeId, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
              for(let i = 0; i < response.data.length; i++){
                //get location in responseLocations where responseLocation.data.id === response.data[i].locationId
                let location = responseLocations.data.find(location => location.id === response.data[i].locationId);
                response.data[i].location = location.name;
              }
          }
          else{
            responseLocations = await axios.get(global.config.url + '/locations/' + response.data[0].locationId, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            for(let i = 0; i < response.data.length; i++){
              response.data[i].location = responseLocations.data.name;
            }
          }


          setLoading(false);
          //add item to clients with lmsConversion value according to client.lms
          for(let i = 0; i < response.data.length; i++){
            response.data[i].lmsConversion = lmsResponse.data[response.data[i].lms];
          }
          setClients(response.data);
          console.log(response.data)
      } catch(error){
          console.error('Error fetching lmsConversion:', error);
          if (handleAccessError(error, { deniedMessage: 'You do not have permission to view clients for this record.' })) {
            setLoading(false);
          }
      }

    } catch (error) {
      console.error('Error fetching client:', error);
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to view clients for this record.' })) {
        setLoading(false);
      }
    }
  };

  const getAccessPoints = () => {

    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to view its access points.'});
    }
    else{
      navigate(`/accesspoints/client/${rowSelectionModel.name}/${rowSelectionModel.id}`);
    }
  };

  const getLogs = () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to view its logs.'});
    }
    else{
      navigate(`/logs/client/${rowSelectionModel.name}/${rowSelectionModel.id}`);
    }
  };

  const getClientLogs = () => {
  
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to view its logs.'});
    }
    else{
      navigate(`/clientlogs/client/${rowSelectionModel.name}/${rowSelectionModel.id}`);
    }
  };

  const getClientStatusLogs = () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to view its status logs.'});
    }
    else{
      navigate(`/clientstatuslogs/${rowSelectionModel.name}/${rowSelectionModel.id}`);
    }
  };

  const exportCSV = (selectionOnly) => {
    dt.current.exportCSV({ selectionOnly });
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    localStorage.setItem('clients-global', JSON.stringify(_filters));

    setFilters(_filters);
    setGlobalFilterValue(value);
  };


  const openComPortForm = () => {
  
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to view its logs.'});
    }
    else{
      let url = "https://airtable.com/appsFESx3sxgOSOKG/shr4FIQpDLfiN05Pj?prefill_PC+Name=" + rowSelectionModel.name + "&prefill_Site+name=" + rowSelectionModel.location;
      // navigate(`/clientlogs/client/${rowSelectionModel.name}/${rowSelectionModel.id}`);
      window.open(url, "_blank");
    }
  }

  const getComPorts = () => {
  
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to view its com ports.'});
    }
    else{
      navigate(`/comports/${rowSelectionModel.id}`);
    }
  };

  const markClientAsInstalled = async () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to mark as installed.'});
      return;
    }
    let conf = window.confirm(`Are you sure you want to mark client ${rowSelectionModel.name} as installed?`);
    if(!conf){
      return;
    }
    clear(true);
    const token = localStorage.getItem('token');
    try {
      let axiosConfig = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
      };
      const response = await axios.get(global.config.url + `/clients/markaslive/${rowSelectionModel.id}`, axiosConfig);
      console.log(response);
      if(response.status === 200){
        msgs.current.show({severity: 'success', summary: '', detail: `Client ${rowSelectionModel.name} successfully marked as installed.`});
        getClients();
        setRowSelectionModel(null);
      }
      else{
        msgs.current.show({severity: 'error', summary: '', detail: 'Error marking the client as installed, please try again.'});
      }
    } catch (error) {
      console.error('Error marking client as installed:', error);
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to update this client.' })) {
        return;
      }
      else{
        msgs.current.show({severity: 'error', summary: '', detail: 'Error marking the client as installed, please try again.'});
      }
    }
  };


  const setClientToRestart = async () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to restart.'});
      return;
    }
    clear(true);
    const token = localStorage.getItem('token');
    try {
      let axiosConfig = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
      };
      const response = await axios.get(global.config.url + `/clients/restartclient/${rowSelectionModel.id}`, axiosConfig);
      console.log(response);
      if(response.status === 200){
        msgs.current.show({severity: 'success', summary: '', detail: `Client ${rowSelectionModel.name} successfully set to restart.`});
        getClients();
        setRowSelectionModel(null);
      }
      else{
        if(response.content !== null && response.content !== undefined){
          msgs.current.show({severity: 'error', summary: '', detail: response.content});
          return;
        }
        msgs.current.show({severity: 'error', summary: '', detail: 'Error setting the client to restart, please try again.'});
      }
    } catch (error) {
      console.error('Error setting client to restart:', error);
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to restart this client.' })) {
        return;
      }
      else{
        if(error.response && error.response.data){
          msgs.current.show({severity: 'error', summary: '', detail: error.response.data});
          return;
        }
        msgs.current.show({severity: 'error', summary: '', detail: 'Error setting the client to restart, please try again.'});
      }
    }
  };

  const startContent = (
    <React.Fragment>
      <div>
        <Button onClick={() => getAccessPoints()} label="Get Access Points" icon="pi pi-qrcode" className="p-button-success mb-3 ml-3" tooltip="Get access points for this client" tooltipOptions={{position:"bottom"}}/>
        <Button onClick={() => getLogs()} label="Get Access Logs" icon="pi pi-file" className="p-button mb-3 ml-3" tooltip="Get access logs for this client" tooltipOptions={{position:"bottom"}}/>
        <Button onClick={() => getClientLogs()} label="Get Client Logs" icon="pi pi-file" className="p-button-danger mb-3 ml-3" tooltip="Get client logs for this client" tooltipOptions={{position:"bottom"}}/>
        <Button onClick={() => getClientStatusLogs()} label="Get Client Status Logs" icon="pi pi-file" className="p-button-warning mb-3 ml-3" tooltip="Get client status logs for this client" tooltipOptions={{position:"bottom"}}/>
      </div>
      <div>
        {/* <Button onClick={() => openComPortForm() } label="Open Com Port Config" icon="pi pi-cog" className="p-button-secondary mb-3 ml-3" tooltip="Open Com Port for this client" tooltipOptions={{position:"bottom"}}/> */}
        <Button onClick={() => getComPorts()} label="Get Com Ports" icon="pi pi-server" className="p-button-warning mb-3 ml-3" tooltip="Get com ports for this client" tooltipOptions={{position:"bottom"}}/>
        <Button onClick={() => markClientAsInstalled()} label="Mark as Installed" icon="pi pi-check" className="p-button-info mb-3 ml-3" tooltip="Mark this client as installed" tooltipOptions={{position:"bottom"}}/>
        <Button onClick={() => setClientToRestart()} label="Set to Restart" icon="pi pi-refresh" className="p-button-primary mb-3 ml-3" tooltip="Set this client to restart" tooltipOptions={{position:"bottom"}}/>
      </div>
    </React.Fragment>
);

  const clearFilter = () => {
  
    let _filters = { ...filters };
    _filters['global'].value = null;
    setFilters(_filters);
    setGlobalFilterValue('');
    localStorage.removeItem('clients-global');
  };

const footerContent = (
  <div>
      <Button label="No" icon="pi pi-times" onClick={() => setCreateVisible(false)} className="p-button-text" />
      <Button label="Yes" icon="pi pi-check" onClick={() => confirm(true)} autoFocus />
  </div>
);

const clear = () => {
  
  toastBC.current.clear();
};

const confirm = (create, newData) => {
  if(create === null){
    toastBC.current.show({
      severity: 'info',
      sticky: true,
      className: 'border-none',
      content: (
          <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
              <div className="text-center">
                  <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                  <div className="font-bold text-xl my-3">Are you sure?</div>
              </div>
              <div className="flex align-items-center">
                  <Button onClick={(e) => updateClient(newData)} type="button" label="Yes" className="p-button-success w-6rem" />
                  <Button onClick={(e) => clear(false)} type="button" label="No" className="p-button-warning w-6rem mx-4" />
              </div>
          </div>
      )
    });
  }
  else
  {
    if(create){
      if(newClientName=== undefined || newClientName === ''){
        toast.current.show({severity: 'error', summary: '', detail: 'Please enter a name for the new client.'});
        return;
      }
      console.log(newClientLms);
      if(newClientLms=== undefined || newClientLms === -1 || newClientLms === ''){
        toast.current.show({severity: 'error', summary: '', detail: 'Please select LMS for the new client.'});
        return;
      }
      toastBC.current.show({
        severity: 'info',
        sticky: true,
        className: 'border-none',
        content: (
            <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
                <div className="text-center">
                    <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                    <div className="font-bold text-xl my-3">Are you sure?</div>
                </div>
                <div className="flex align-items-center">
                    <Button onClick={(e) => createClient()} type="button" label="Confirm" className="p-button-success w-6rem" />
                    <Button onClick={(e) => clear(false)} type="button" label="Cancel" className="p-button-warning w-6rem mx-4" />
                </div>
            </div>
        )
      });
    }
    else{
      toastBC.current.show({
        severity: 'info',
        sticky: true,
        className: 'border-none',
        content: (
            <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
                <div className="text-center">
                    <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                    <div className="font-bold text-xl my-3">Are you sure?</div>
                </div>
                <div className="flex align-items-center">
                    <Button onClick={(e) => deleteClient()} type="button" label="Confirm" className="p-button-success w-6rem" />
                    <Button onClick={(e) => clear(false)} type="button" label="Cancel" className="p-button-warning w-6rem mx-4" />
                </div>
            </div>
        )
      });
    }
  }

};

const createClient = async () => {
  clear(true);
  var lmsKey = getKeybyValue(lmsConversion, newClientLms);
  const token = localStorage.getItem('token');
  var newClient = {
    id: 0,
    name: newClientName,
    locationId: typeId,
    status: false,
    lms: lmsKey
  }
  let axiosConfig = {
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
    }
  };
  try {

    const response = await axios.post(global.config.url + '/clients', newClient, axiosConfig);
    console.log(response);
    if(response.status === 201){
      msgs.current.show({severity: 'success', summary: '', detail: `Client ${response.data.name} successfully created.`});
      getClients();
      setCreateVisible(false);
      setNewClientLms(0);
      setNewClientName('');
    }
    else{
      toast.current.show({severity: 'error', summary: '', detail: 'Error creating the client, please try again.'});
    }

  } catch (error) {
    console.error('Error fetching customers:', error);
    if (handleAccessError(error, { deniedMessage: 'You do not have permission to create clients for this record.' })) {
      return;
    }
    else if(error.response && error.response.status === 400){
      toast.current.show({severity: 'error', summary: '', detail: 'Error creating the client, please try again.'});
    }
    else if(error.response && error.response.status === 500){
      toast.current.show({severity: 'error', summary: '', detail: 'Error creating the client, please try again.'});
    }
    else if(error.response && error.response.status === 409){
      toast.current.show({severity: 'error', summary: '', detail: error.response.data});
    }
  }

};

const deleteClient = async () => {
  clear(true);
  const token = localStorage.getItem('token');
  if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
    msgs.current.show({severity: 'error', summary: '', detail: 'Please select a client to delete.'});
    return;
  }
  try {
    let axiosConfig = {
      headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
      }
    };
    const response = await axios.delete(global.config.url + `/clients/${rowSelectionModel.id}`, axiosConfig);
    console.log(response);
    if(response.status === 204){
      msgs.current.show({severity: 'success', summary: '', detail: `Client deleted successfully.`});
      getClients();
      setCreateVisible(false);
    }
    else{
      toast.current.show({severity: 'error', summary: '', detail: 'Error deleting the client, please try again.'});
    }

  } catch (error) {
    console.error('Error fetching customers:', error);
    if (handleAccessError(error, { deniedMessage: 'You do not have permission to delete this client.' })) {
      return;
    }
    else if(error.response && error.response.status === 400){
      toast.current.show({severity: 'error', summary: '', detail: 'Error deleting the client, please try again.'});
    }
    else if(error.response && error.response.status === 500){
      toast.current.show({severity: 'error', summary: '', detail: 'Error deleting the client, please try again.'});
    }
  }
  
};

const updateClient = async (newData) => {
  try{
    clear(true);
    const token = localStorage.getItem('token');
    var axiosConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    };
    const response = await axios.put(global.config.url + `/clients/${newData.id}`, newData, axiosConfig);
    console.log(response);
    if(response.status === 204){
      msgs.current.show({severity: 'success', summary: '', detail: `Client ${newData.name} successfully updated.`});
      getClients();
      setCreateVisible(false);
    }
    else{
      msgs.current.show({severity: 'error', summary: '', detail: 'Error updating the client.'});
    }
  } catch (error) {
    console.error('Error updating client:', error);
    if (handleAccessError(error, { deniedMessage: 'You do not have permission to update this client.' })) {
      return;
    }
  }
};


const getKeybyValue = (object, value) => {
  return Object.keys(object).find(key => object[key] === value);
}

  const getSeverity = (client) => {
    switch (client.status) {
        case true:
            return 'success';

        case false:
            return 'danger';

        default:
            return null;
    }
};

const setClientChanges = (clients) => {
  //call db to update access points
  setClients(clients);
}

const onRowEditComplete = (e) => {

  let { newData, index } = e;
  let lmsName = newLmsName;
  if(lmsName === undefined || lmsName === ''){
    lmsName = lmsConversion[newData.lms];
  }
  console.log(lmsConversion)
  let lmsKey = getKeybyValue(lmsConversion, lmsName);
  newData.lms = lmsKey;
  let _clients = [...clients];
  _clients[index] = newData;
  setClientChanges(_clients);
  confirm(null, newData);
};

const textEditor = (options) => {
  return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
};

const setNewLms = (options, value) => {
  options.editorCallback(value);
  setNewLmsName(value);
}

const lmsEditor = (options) => {
  if (accessIssue) {
    return <AccessState {...accessIssue} />;
  }

  return (
      <Dropdown
          value={options.value}
          options={lms}
          onChange={(e) => setNewLms(options, e.value)}
          placeholder="Select a LMS"
      />
  );
};

  const statusBodyTemplate = (client) => {
    let string = client.status ? 'Online' : 'Offline';
      return <Tag value={string} severity={getSeverity(client)}></Tag>;
  };

  const optionsSelected = (e, rowData) =>{
    op.current.toggle(e);
    setRowSelectionModel(rowData);
  }

  const optionsTemplate = (rowData) => {
    return <Button link icon="pi pi-ellipsis-v" onClick={(e) => optionsSelected(e, rowData)} />;
  };

  const progressbar = (        
    <div className="card mt-3">
        <ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
    </div>);

    const goBack = () => {
  
      localStorage.removeItem('clients-global');
      navigate(-1);
    }

  return (
      <Container fluid="md" className='justify-content-md-center mt-5'>

        <div className="flex align-items-right my-3">
          <Container className="flex align-content-center flex-wrap">
            <Button link icon="pi pi-arrow-left" onClick={() => goBack()} className='flex mb-3'/> 
            <h4 className='flex mt-2 mb-3 ml-3'>Clients for {type.toLocaleLowerCase()} '{typeName}'</h4> 
            <div>
              <span className="p-input-icon-right ml-3 mb-3">
                <i className="pi pi-search" />
                <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Filter by name or location name" tooltip="Start typing a client or location name to filter" tooltipOptions={{position: "bottom"}} />
              </span>
              <Button icon="pi pi-times" className="p-button-text mb-3 ml-2" onClick={clearFilter} tooltip="Clear filter" tooltipOptions={{position: "bottom"}} />
              <Button icon="pi pi-refresh" className="p-button-text mb-3" onClick={() => getClients()} disabled={loading} tooltip="Refresh clients" tooltipOptions={{position: "bottom"}} />
              <Button icon="pi pi-plus" className="p-button-success ml-3 mb-3" rounded disabled={loading} onClick={() => setCreateVisible(true)} tooltip="Create new client" tooltipOptions={{position: "bottom"}} />
              {/* <Button icon="pi pi-trash" className="p-button-danger" rounded disabled={loading} onClick={() => confirm(false)} tooltip="Delete selected client" tooltipOptions={{position: "bottom"}} /> */}
              <Button type="button" icon="pi pi-file-export" className='ml-3 mb-3' rounded disabled={loading} onClick={() => exportCSV(false)} tooltip="Download as csv" tooltipOptions={{position: "bottom"}} />
            </div>
          </Container>
        </div>
        <Messages ref={msgs} />
        <Toast ref={toastBC} position="top-center" />
        {loading && progressbar}

        <div className='justify-content-md-center mt-3'>
            <DataTable value={clients} selectionMode={'single'} selection={rowSelectionModel} onSelectionChange={(e) => setRowSelectionModel(e.value)} 
              dataKey="id" tableStyle={{ minWidth: '10rem' }} filters={filters} ref={dt} emptyMessage={loading ? "Loading clients..." : "No clients found."}
              globalFilterFields={['name', 'status', 'lmsConversion', 'location']} editMode='row' onRowEditComplete={onRowEditComplete}
              scrollable scrollHeight='80vh'>
                <Column field="options" header="" body={optionsTemplate}> </Column>
                <Column field="name" header="Name" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} 
                  editor={(options) => textEditor(options)} sortable></Column>
                <Column header="Status" body={statusBodyTemplate}></Column>
                <Column field="lmsConversion" header="LMS" editor={(options) => lmsEditor(options)}></Column>
                <Column field="location" header="Location" sortable></Column>
                <Column field="versionNumber" header="Version Number" style={{ minWidth: '8rem' }} sortable></Column>
                <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>

          </DataTable>
          <OverlayPanel ref={op}>
            {startContent}
          </OverlayPanel>
        </div>
        <div className="card flex justify-content-center">
          <Dialog header="Create Client" className='justify-content-center' visible={createVisible} onHide={() => setCreateVisible(false)} 
            style={{ width: 'auto' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} footer={footerContent}>
            <Toast ref={toast} />
            <Container className="flex align-content-center flex-wrap">
              <span className="flex p-float-label my-4">

                <InputText
                    id="name"
                    name="name"
                    value={newClientName}
                    onChange={(e) => setNewClientName(e.target.value)}
                />
                <label htmlFor="input_name">Name</label>
              </span>
              <span className="flex p-float-label my-4 ml-3">
                <Dropdown
                  inputId="dd-lms"
                  value={newClientLms}
                  options={lms}
                  onChange={(e) => setNewClientLms(e.value)}
                  placeholder="Select an LMS"    

                />
                <label htmlFor="dd_lms">Select an LMS</label>
              </span>
            </Container>
          </Dialog>
        </div>
        <ScrollTop />
      </Container>
  );
};

export default Clients;
